import React from "react"
import { isBlackFridayPopupActive } from "utils/dateUtils"
import { ENABLE_BLACK_FRIDAY_POPUP } from "config/campaignFeatureToggles"
import BfPopup from "views/productsList/blackFriday/BfPopup"

/** Black Friday 2026 popup no. 1: from the start until the last morning. */
const BlackFridayPopup = () => {
  if (!ENABLE_BLACK_FRIDAY_POPUP) return null
  if (!isBlackFridayPopupActive()) return null

  return <BfPopup variant="start" storageKey="blackFridayPopup2026Dismissed" />
}

export default BlackFridayPopup
